import React from 'react';
import autoBind from 'react-autobind';
import _ from 'lodash';
import DDadosBase from '@common/components/ddados/ddados.base';
import Field from '@common/components/validation/field.validation';
import AccessControl from '@common/components/accessControl/accessControl.component';
import { Row, Col } from 'react-bootstrap';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
    this.state = {
      showLookup: false,
    };
    autoBind(this);
  }

  get buttonSize() {
    return this.props.TamanhoButons || 10 - (this.props.TamanhoSuggestion || 12);
  }

  onOpenLookup() {
    if (_.isFunction(this.props.onClick)) this.props.onClick();
    this.setState({ showLookup: true });
  }

  onCloseLookup() {
    this.setState({ showLookup: false });
  }

  onSelectLookup(onChange) {
    return (dataItem) => {
      const { mapLookupItem } = this.props;
      const item = mapLookupItem ? mapLookupItem(dataItem) : dataItem;
      onChange(item);
      this.onCloseLookup();
    };
  }

  onChange(field, form) {
    return (e) => {
      form.setFieldValue(this.props.name, e);
      this.dispatchChanges(e, form, field);
    };
  }

  renderComponent() {
    const { props } = this;
    const { Tooltip, Desabilitado, lookup, buttons, name, icon, nameButton } = props;

    return (
      <Field {...props}>
        {({ value, onChange, form }) => {
          return (
            <Row>
              {lookup && (
                <Col lg={this.buttonSize} style={{ paddingTop: 29 }}>
                  <div className="container-lookup div-button-right">
                    <button
                      type="button"
                      className="btn btn-primary btn-custom"
                      title={Tooltip}
                      onClick={this.onOpenLookup}
                      disabled={Desabilitado}
                      name={name}
                    >
                      <div>
                        {nameButton ? nameButton : <i className={`pointer-events-none ${icon || 'fa fa-search'}`} />}
                      </div>
                    </button>
                    {React.cloneElement(lookup, {
                      onSelect: this.onSelectLookup(onChange).bind(this),
                      onClose: this.onCloseLookup.bind(this),
                      show: this.state.showLookup,
                    })}
                  </div>
                </Col>
              )}

              {buttons &&
                buttons.map((item, i) => (
                  <AccessControl key={i} name={item.route} url={item.url}>
                    <button
                      style={{ marginTop: '29px' }}
                      type="button"
                      className="btn btn-primary btn-custom"
                      disabled={!item.dontDisable && !value}
                      title={item.title}
                      onClick={() => item.onClick(form.values)}
                      name={name}
                    >
                      <i className={`pointer-events-none ${item.icon}`} />
                    </button>
                  </AccessControl>
                ))}
            </Row>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>{(field.value || {}).Exibicao || ''}</label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default DDadosComponent;
